import { z } from "zod";

export const categorySchema = () => {
  return z.object({
    name: z.string().min(1),
    icon: z.string().optional(),
    order: z.any().optional(),
    active: z.boolean().optional(),
  });
};

export type CategoryFormValues = z.infer<ReturnType<typeof categorySchema>>;
